module.exports = __webpack_public_path__ + "img/code.792b0d28.png";